export const handleSubmit = ({ createCustomer, customerId, history }) => values => {
  const updatedData = createCustomer({
    variables: {
      customerInput: {
        ...values,
      },
      customerId,
    },
  });

  return updatedData.then(result => {
    const customer = result.data ? result.data.createCustomer : null;
    if (customer && customer._id) {
      history.replace(`/customer/details/${customer._id}`);
    }
  });
};
